import FbWorkspace from '@/pages/facebook/FbWorkspace';

/**
 * Instagram workspace — the same campaign-builder shell as the Facebook
 * workspace, configured for Instagram. The underlying data model is
 * identical (Meta has no separate IG campaign object), but with
 * `platform="instagram"` set:
 *
 *   - placements are locked to Instagram-only on every ad set
 *   - `publisher_platforms` is forced to `["instagram"]` on save so the
 *     campaign cannot accidentally serve on Facebook / Audience Network /
 *     Messenger
 *   - the ad form forces `runOnIg=true` and surfaces a warning if no
 *     Instagram account is connected to the ad account
 *   - draft auto-save uses a separate localStorage key so a half-finished
 *     IG campaign doesn't clobber a half-finished FB campaign
 *
 * All other features — multi-ad-set, multi-ad-per-set, locations picker,
 * interests, languages, custom audiences, Advantage+, schedule, bid
 * strategy, optimization goal override, conversion event for SALES,
 * AI-assisted draft generation — are inherited from the FB workspace as-is.
 */
export default function IgWorkspace() {
  return <FbWorkspace platform="instagram" />;
}
